import { render, staticRenderFns } from "./PriceManage.vue?vue&type=template&id=72603d9d"
import script from "./PriceManage.vue?vue&type=script&lang=js"
export * from "./PriceManage.vue?vue&type=script&lang=js"
import style0 from "./PriceManage.vue?vue&type=style&index=0&id=72603d9d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports